import React, { useState } from "react";
import { Link } from "react-router-dom";
import { QrCode } from "../assets/icons";
import {
  HiHome,
  HiOutlineHome,
  HiMagnifyingGlass,
  HiOutlineMagnifyingGlass,
  HiShoppingBag,
  HiOutlineShoppingBag,
  HiGift,
  HiOutlineGift,
  HiOutlineSparkles,
} from "react-icons/hi2";
import { QRCode } from "react-qrcode-logo";
import { Avatar, Button, Modal } from "antd";
import { useSelector, connect } from "react-redux";
import { useEffect } from "react";

const Footer = ({ active, disable, isOrganise, isService, merchanturl }) => {
  // const { organisation_id, card_id } = useParams();
  const storageUser = localStorage.getItem("user_customer_details") ?? null;
  const user = (storageUser !== undefined && storageUser !== null) ? JSON.parse(storageUser) : null;
  const [showProfile, setShowProfile] = useState(false);
  const { merchantDetails } = useSelector((state) => state.merchant);
  const { carts } = useSelector((state) => state.Order);
  const { giftcard } = useSelector((state) => state.urewardsAuth);
  const [orgId, setOrgId] = useState("");
  const [carddId, setCarddId] = useState("");
  const logoutUser = () => {
    localStorage.clear();
    window.location.href = "/home";
  };

  useEffect(() => {
    const checkFi = localStorage.getItem("organ_params") ?? null;
    if (checkFi) {
      const newFi = JSON.parse(checkFi);
      setCarddId(newFi.card_id);
      setOrgId(newFi.organisation_id);
    }
  }, []);

  const totalOrder = (cart) => {
    if (cart && cart.length === 0 ) return 0;
    const cartItemWithVariants = cart.filter((item)=>{
      return item.variants && item.variants.length > 0;
    });

    const cartItemsWithCust = cart.filter((item)=>{
      return item.custom_quantities && item.custom_quantities.length > 0;
    });

    const cartBundle = cart.filter((item)=>{
      return item.bundle_quantity && typeof item.bundle_quantity === "object";
    });

    const normItem = cart.filter((item)=>{
      return item.variants && item.variants.length === 0 && item.custom_quantities && item.custom_quantities.length === 0;
    });
    
    const totalVaraiant = cartItemWithVariants.reduce((prev, curr)=>{
      return Number(prev) + (Number(curr.quantity) * Number(curr.variants[0].price));
    }, 0);

    const totalCust = cartItemsWithCust.reduce((prev, curr)=>{
      return Number(prev) + (Number(curr.quantity) * Number(curr.custom_quantities[0].price));
    }, 0);

    const totalBundle = cartBundle.reduce((prev, curr)=>{
      return Number(prev) + (Number(curr.quantity) * Number(curr.price));
    }, 0);

    const otherTotal = normItem.reduce((prev, curr) => {
      return prev + Number(curr.quantity) * Number(curr.price);
    }, 0); 

    return otherTotal + totalCust + totalVaraiant + totalBundle;
  };

  return (
    <>
      {showProfile && (
        <Modal
          open={showProfile}
          onCancel={() => setShowProfile(false)}
          className="profile_modal"
          footer={null}
        >
          <div className="sign_up_content">
            <div>
              <Avatar src={QrCode} size="large" />
              <span
                style={{
                  margin: "25px 0 0 -13px",
                  position: "absolute",
                }}
              ></span>
            </div>

            <div style={{ marginTop: 20 }}>
              <h3
                className="title_text"
                style={{ textAlign: "center", margin: 0 }}
              >
                {user.first_name}
              </h3>
            </div>

            <div className="flex_center_column">
              <QRCode
                size={250}
                quietZone={50}
                value={`${process.env.REACT_APP_LOYSTAR_BASE_URL}/me/${user.phone_number}`}
                bgColor="#FFFFFF"
                fgColor="#0F0F10"
                qrStyle="dots"
                ecLevel="H"
                eyeRadius={[
                  {
                    outer: [10, 10, 0, 10],
                    inner: [0, 10, 10, 10],
                  },
                  [10, 10, 10, 0],
                  [10, 0, 10, 10],
                ]}
              />
              <div style={{ height: 40 }}></div>
            </div>

            {!user.address && (
              <div className="flex_center_column">
                <p>Phone Number</p>
                <p>{user.phone_number}</p>
              </div>
            )}
            {user.address && (
              <div className="contact_address">
                <div className="contact">
                  <p>Phone Number</p>
                  <p>{user.phone_number}</p>
                </div>
                <div className="address">
                  <p>Address</p>
                  <p>{user.address || "Nil"}</p>
                </div>
              </div>
            )}

            {/* <div style={{ marginTop: 30 }}>
							<p>
								<b>Complete this Task and Earn some Points</b>
							</p>
							<p style={{ color: "#6B6A6A" }}>
								Lorem ipsum dolor sit amet, consectetur adipiscing elit.sed do
								eiusmod tempor
							</p>
						</div> */}

            {/* <div style={{ marginTop: 30 }}>
							<Button
								style={{
									background: "#6B6A6A",
									width: "100%",
									height: "63px",
									marginBottom: 20,
								}}
								type="primary">
								<span>Update Your Contact</span>
							</Button>
							<Button
								style={{
									background: "#6B6A6A",
									width: "100%",
									height: "63px",
									marginBottom: 20,
								}}
								type="primary">
								<span>3 Daily Purchases</span>
							</Button>
							<Button
								style={{
									background: "#6B6A6A",
									width: "100%",
									height: "63px",
									marginBottom: 20,
								}}
								type="primary">
								<span>Visit 3 Stores</span>
							</Button>
						</div> */}

            <div className="logout">
              <Button
                style={{
                  background: "#0F0F10",
                  color: "#fff",
                  border: "none",
                  width: "100%",
                  height: "63px",
                  marginBottom: 20,
                }}
                onClick={logoutUser}
                type="primary"
              >
                <span>Logout</span>
              </Button>
            </div>
          </div>
        </Modal>
      )}

      <div style={{ height: disable ? 96 : 92 }}></div>
      {(() => {
        const currency =
          merchantDetails && merchantDetails.currency ? merchantDetails.currency : "";
        const cartCount = carts ? carts.length : 0;
        const accentStyle = isOrganise ? { "--ls-accent": isOrganise } : undefined;

        // Storefront pages (disable): Shop-style floating cart pill.
        if (disable) {
          if (isService && giftcard === null) return null;
          return (
            <div className="ls-floating-bar" style={accentStyle}>
              {giftcard !== null && (
                <Link to={`/o/${orgId}/${carddId}`} className="ls-floating-bar__home" aria-label="Home">
                  <HiOutlineHome />
                </Link>
              )}
              {!isService && (
                <Link to="/cart" id="cartBasket" className={`ls-floating-bar__cart${cartCount === 0 ? " is-empty" : ""}`}>
                  <span className="ls-floating-bar__icon">
                    <HiOutlineShoppingBag />
                    {cartCount > 0 && <span className="ls-floating-bar__count">{cartCount}</span>}
                  </span>
                  <span className="ls-floating-bar__label">
                    {cartCount === 0 ? "Your cart is empty" : "View cart"}
                  </span>
                  {cartCount > 0 && (
                    <span className="ls-floating-bar__total">
                      {currency}
                      {totalOrder(carts).toFixed(2)}
                    </span>
                  )}
                </Link>
              )}
            </div>
          );
        }

        return (
          <nav className="footer_div" style={accentStyle} aria-label="Primary">
            <Link to={merchanturl ? merchanturl : ""}>
              <div className={active === "home" ? "nav_item active" : "nav_item"}>
                {active === "home" ? <HiHome /> : <HiOutlineHome />}
                <span>Home</span>
              </div>
            </Link>
            <Link to="/discover">
              <div className={active === "discover" ? "nav_item active" : "nav_item"}>
                {active === "discover" ? <HiMagnifyingGlass /> : <HiOutlineMagnifyingGlass />}
                <span>Discover</span>
              </div>
            </Link>
            {giftcard !== null && (
              <Link to={`/o/${orgId}/${carddId}`}>
                <div className={active === "home" ? "nav_item active" : "nav_item"}>
                  <HiOutlineSparkles />
                  <span>Home</span>
                </div>
              </Link>
            )}
            {!isService && (
              <Link to="/cart">
                <div className={active === "cart" ? "nav_item active" : "nav_item"} id="cartBasket">
                  <div style={{ position: "relative" }}>
                    {active === "cart" ? <HiShoppingBag /> : <HiOutlineShoppingBag />}
                    {cartCount > 0 && <sup className="ls-cart-badge">{cartCount}</sup>}
                  </div>
                  <span>
                    {cartCount === 0 ? "Cart" : currency + totalOrder(carts).toFixed(2)}
                  </span>
                </div>
              </Link>
            )}
            <Link to="/rewards">
              <div className={active === "rewards" ? "nav_item active" : "nav_item"}>
                {active === "rewards" ? <HiGift /> : <HiOutlineGift />}
                <span>Rewards</span>
              </div>
            </Link>
          </nav>
        );
      })()}
    </>
  );
};

const mapStateToProps = (state) => ({
  state: state,
  carts: state.carts,
  merchantDetails: state.merchantDetails,
  urewardsAuth: state.urewardsAuth,
});
export default connect(mapStateToProps)(Footer);
